// A trail leaving the board (a crashed worm's, when worms come back in): its
// shape is kept for a moment and played out on the per-frame layer while the
// game has already let go of it (worm-body-renderer, from the trail_cleared
// events of core respawn.js). Each leaving run is one entry:
//   { at: game time it went, points: [{x, y, r}] tail to head, dist: [...], len, color, size }
// (r: the trail's width there, a fat or thin power-up's part keeps its own)
// It breaks into pellets from the crash point back to the tail, which drift
// apart, shrink and are gone.

export var TRAIL_FADE_SECONDS = 0.9;

// A track's segments as points along the trail (game units), every ~`step` units (3).
export function trailPoints(segments, step) {
    step = step || 3;
    var pts = [];
    for (var i = 0; i < segments.length; i++) {
        var seg = segments[i];
        if (seg.type === "worm_died" || seg.type === "clear" || seg.duration <= 0) continue;
        if (seg.jump || seg.type === "still_arc" || seg.speed === 0) { pts.push(null); continue; } // a gap
        if (seg.type === "arc") {
            var steps = Math.max(1, Math.ceil(Math.abs(seg.arcAngleDiff * seg.arcRadius) / step));
            for (var s = 0; s <= steps; s++) {
                var a = seg.arcStartAngle + (s / steps) * seg.arcAngleDiff;
                pts.push({ x: seg.arcCenterX + seg.arcRadius * Math.cos(a), y: seg.arcCenterY + seg.arcRadius * Math.sin(a), r: seg.size });
            }
        } else {
            var d = Math.hypot(seg.endX - seg.startX, seg.endY - seg.startY);
            var n = Math.max(1, Math.ceil(d / step));
            for (var k = 0; k <= n; k++) pts.push({ x: seg.startX + (k / n) * (seg.endX - seg.startX), y: seg.startY + (k / n) * (seg.endY - seg.startY), r: seg.size });
        }
    }
    // distances along the trail (a gap adds nothing)
    var dist = [], total = 0, prev = null;
    for (var j = 0; j < pts.length; j++) {
        var p = pts[j];
        if (p && prev) total += Math.hypot(p.x - prev.x, p.y - prev.y);
        dist.push(total);
        prev = p;
    }
    return { points: pts, dist: dist, len: total };
}

var easeIn = function (t) { return t * t; };
// a stable random per point index
var rnd = function (i) { var s = Math.sin(i * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); };

// Draw one leaving trail at progress p (0..1).
export function drawTrailFade(ctx, sc, scale, f, p) {
    if (p >= 1 || !f.points.length) return;
    ctx.save();
    ctx.fillStyle = f.color;
    ctx.strokeStyle = "#ffcf4d";
    for (var i = 0, next = 0; i < f.points.length; i++) {
        var pt = f.points[i];
        if (!pt || f.dist[i] < next) continue;
        var size = pt.r || f.size;
        next = f.dist[i] + Math.max(6, size * 2.6);
        // the crash point's end goes first
        var delay = (1 - f.dist[i] / Math.max(1, f.len)) * 0.35;
        var q = Math.max(0, Math.min(1, (p - delay) / (1 - delay)));
        var drift = easeIn(q) * size * 4, ang = rnd(i) * Math.PI * 2;
        var rad = size * (1.15 - q * 1.15) * (q < 0.15 ? 1 + q * 2 : 1);
        if (rad <= 0.05) continue;
        var x = pt.x + Math.cos(ang) * drift, y = pt.y + Math.sin(ang) * drift;
        ctx.globalAlpha = 1 - q * 0.6;
        ctx.beginPath(); sc.arc(x, y, rad, 0, Math.PI * 2); ctx.fill();
        // a gold rim, thinning with the pellet so no speck outlives it
        ctx.globalAlpha = (1 - q) * 0.5;
        ctx.lineWidth = scale * 0.8 * Math.min(1, rad / size);
        ctx.beginPath(); sc.arc(x, y, rad, 0, Math.PI * 2); ctx.stroke();
    }
    ctx.restore();
}
